import ReactDOM from "react-dom/client";
import "@fontsource/noto-sans-armenian";
import * as Sentry from "@sentry/react";

import App from "./src/App";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [],
  tracesSampleRate: 1.0,
  environment: import.meta.env.MODE,
});

const element = document.getElementById("app");
const appRoot = ReactDOM.createRoot(element);

appRoot.render(<App />);
